import React from "react";
const EventInfoContext = React.createContext();

export default EventInfoContext;
